import { render } from "./RecoveryView.vue?vue&type=template&id=7b726816&ts=true"
import script from "./RecoveryView.vue?vue&type=script&lang=ts"
export * from "./RecoveryView.vue?vue&type=script&lang=ts"

import "./RecoveryView.vue?vue&type=style&index=0&id=7b726816&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__